module.exports = __webpack_public_path__ + "img/img4.fb59bd09.svg";